export function formatCurrency(amount: number): string {
  // Use explicit Ghana Cedi symbol to avoid browser encoding issues
  const formatted = new Intl.NumberFormat('en-GH', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
  // Place negative sign before the currency symbol for tests and display consistency
  if (Object.is(amount, -0)) return `GH₵0.00`;
  if (amount < 0) {
    return `-${'GH₵'}${formatted.replace('-', '')}`;
  }
  return `GH₵${formatted}`;
}

export const CURRENCY_SYMBOL = 'GH₵';
